(function () {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer || !window.TI) return;
  var linesEl = drawer.querySelector('[data-cart-lines]');
  var footEl = drawer.querySelector('[data-cart-foot]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var lastFocus = null;

  function money(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var fmt = window.TI.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function jarHtml() {
    return '<div class="jar jar--sm" aria-hidden="true"><div class="jar__lid"></div><div class="jar__body"></div></div>';
  }
  function propsHtml(props) {
    if (!props) return '';
    var curated = props._curated;
    var rows = Object.keys(props).filter(function (k) { return k.charAt(0) !== '_' && props[k] !== '' && props[k] != null; })
      .map(function (k) { return '<li>' + (curated ? esc(props[k]) + ' × ' + esc(k) : esc(k) + ': ' + esc(props[k])) + '</li>'; });
    return rows.length ? '<ul class="line__props">' + rows.join('') + '</ul>' : '';
  }
  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function render(cart) {
    updateCount(cart.item_count);
    if (!cart.item_count) {
      linesEl.innerHTML = '<div class="drawer__empty"><p>Your cart is empty.</p><a class="btn btn--ink" href="/#shop" data-cart-close>Shop the collection</a></div>';
      footEl.hidden = true;
      return;
    }
    linesEl.innerHTML = cart.items.map(function (item, i) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var media = item.image
        ? '<div class="line__media line__media--img"><img src="' + esc(item.image) + '&width=200" alt=""></div>'
        : '<div class="line__media">' + jarHtml() + '</div>';
      return '<div class="line">' + media +
        '<div class="line__info">' +
          '<div class="line__top"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a><span>' + money(item.final_line_price) + '</span></div>' +
          (variant ? '<span class="line__variant">' + esc(variant) + '</span>' : '') +
          propsHtml(item.properties) +
          '<div class="line__actions">' +
            '<div class="qty">' +
              '<button type="button" aria-label="Decrease quantity" data-qty="' + (item.quantity - 1) + '" data-line="' + (i + 1) + '">−</button>' +
              '<span style="width:28px;text-align:center">' + item.quantity + '</span>' +
              '<button type="button" aria-label="Increase quantity" data-qty="' + (item.quantity + 1) + '" data-line="' + (i + 1) + '">+</button>' +
            '</div>' +
            '<button type="button" class="link-btn" data-qty="0" data-line="' + (i + 1) + '">Remove</button>' +
          '</div>' +
        '</div></div>';
    }).join('');
    subtotalEl.textContent = money(cart.total_price);
    footEl.hidden = false;
  }

  function fetchCart() {
    return fetch(window.TI.routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function open() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('.drawer__head [data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  function openWithCart() { fetchCart().then(render).then(open); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open]');
    if (t) { e.preventDefault(); openWithCart(); return; }
    if (e.target.closest('[data-cart-close]')) { close(); return; }
    var q = e.target.closest('[data-qty]');
    if (q && drawer.contains(q)) {
      q.disabled = true;
      fetch(window.TI.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(q.dataset.line), quantity: Math.max(0, Number(q.dataset.qty)) })
      }).then(function (r) { return r.json(); }).then(render);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(window.TI.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) { render(cart); open(); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  // Curated Collection builder: pick N items, add one bundle line with the picks attached
  document.querySelectorAll('[data-curated]').forEach(function (root) {
    var target = Number(root.dataset.target) || 8;
    var variantId = root.dataset.variant;
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-item]'));
    var counts = new Map(rows.map(function (r) { return [r, 0]; }));
    var chosenEl = root.querySelector('[data-chosen]');
    var barEl = root.querySelector('[data-bar]');
    var listEl = root.querySelector('[data-list]');
    var addBtn = root.querySelector('[data-curated-add]');

    function total() { var t = 0; counts.forEach(function (n) { t += n; }); return t; }
    function update() {
      var t = total();
      rows.forEach(function (r) {
        var n = counts.get(r);
        r.querySelector('[data-count]').textContent = n;
        r.classList.toggle('is-picked', n > 0);
        r.querySelector('[data-step="-1"]').disabled = n === 0;
        r.querySelector('[data-step="1"]').disabled = t >= target;
      });
      chosenEl.textContent = t;
      barEl.style.width = Math.min(100, (t / target) * 100) + '%';
      var picked = rows.filter(function (r) { return counts.get(r) > 0; });
      listEl.innerHTML = picked.length
        ? picked.map(function (r) { return '<li>' + counts.get(r) + ' × ' + esc(r.dataset.item) + '</li>'; }).join('')
        : '<li class="small" style="color:var(--soft)">Use + to add items.</li>';
      addBtn.disabled = t !== target;
      addBtn.textContent = t === target ? 'Add collection to cart' : (t > target ? 'Remove ' + (t - target) : 'Choose ' + (target - t) + ' more');
    }
    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-step]');
      if (!step) return;
      var row = step.closest('[data-item]');
      var n = counts.get(row) + Number(step.dataset.step);
      if (n < 0 || (Number(step.dataset.step) > 0 && total() >= target)) return;
      counts.set(row, n);
      update();
    });
    root.querySelector('[data-curated-clear]').addEventListener('click', function () {
      rows.forEach(function (r) { counts.set(r, 0); });
      update();
    });
    addBtn.addEventListener('click', function () {
      if (total() !== target) return;
      var properties = { _curated: '1' };
      rows.forEach(function (r) { if (counts.get(r) > 0) properties[r.dataset.item] = String(counts.get(r)); });
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch(window.TI.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: properties }] })
      })
        .then(function (r) { if (!r.ok) throw r; return fetchCart(); })
        .then(function (cart) {
          render(cart); open();
          rows.forEach(function (r) { counts.set(r, 0); });
          update();
        })
        .catch(function () { addBtn.textContent = 'Something went wrong — try again'; addBtn.disabled = false; });
    });
    update();
  });

  // Product page quantity stepper
  document.querySelectorAll('[data-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentNode.querySelector('input');
      input.value = Math.max(1, Number(input.value || 1) + Number(b.dataset.qtyStep));
    });
  });
  // Swap the photo to the chosen scent's image (cards, product page, bundles)
  document.addEventListener('change', function (e) {
    var t = e.target, src = null;
    if (t.tagName === 'SELECT' && t.selectedOptions[0]) src = t.selectedOptions[0].getAttribute('data-img');
    else if (t.checked) src = t.getAttribute('data-img');
    if (!src) return;
    var scope = t.closest('[data-media-scope]');
    var img = scope && scope.querySelector('img[data-variant-img]');
    if (!img) return;
    img.removeAttribute('srcset'); img.removeAttribute('sizes');
    img.src = src;
  });
  // Product page price update on scent change
  var priceData = document.querySelector('script[data-variant-prices]');
  var pdpForm = document.querySelector('form.pdp-form');
  if (priceData && pdpForm) {
    var prices = {};
    try { prices = JSON.parse(priceData.textContent); } catch (err) {}
    var priceEl = document.querySelector('[data-pdp-price]');
    pdpForm.addEventListener('change', function (e) {
      if (e.target.name === 'id' && priceEl && prices[e.target.value] != null) priceEl.textContent = money(prices[e.target.value]);
    });
  }
})();
